"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Provisioning Data Change Service
 * Service for provisioning data changes.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: SignInTeam@xperi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupName = void 0;
/**
 * The group name for the client APIs.
 * @export
 * @enum {string}
 */
exports.GroupName = {
    BodyInfo: 'bodyInfo',
    ProviderConfig: 'providerConfig',
    FeFav: 'feFav',
    Channels: 'channels'
};
